import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDatepicker, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../Model/Combo/combo.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { SessionService } from '../Util/Session/session.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-prequisite-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, NgSelectModule, LoaderComponent],
  templateUrl: './prequisite-form.component.html',
  styleUrl: './prequisite-form.component.scss'
})
export class PrequisiteFormComponent {

  @Input() row: any;
  PerquisiteLoad = [] as any;
  isDisabled: boolean = false;
  perquisiteName = '';

  Data = {
    empCode: '',
    empType: '',
    monthYear: null as any,
    perquisite: null,
    subHeadName: '',
    grossValue: 0,
    employeeRecovery: 0
  }

  startDate = {
    year: 2026,
    month: 4,
    day: 1
  } as any;

  user = {} as any;

  constructor(
    private comboload: ComboService,
    private session: SessionService,
    private activeModal: NgbActiveModal,
    private dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal
  ) {
    this.user = session.GetUserDetails();
  }

  ngOnInit() {
    this.PerquisiteTransactionDetailsLoad();
  }

  onNavigate(event: any) {
    this.Data.monthYear = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  PerquisiteTransactionDetailsLoad() {
    this.isDisabled = true;
    this.comboload.PerquisiteTransactionDetailsLoad({
      OperationType: 'PM',
      FromMonthYear: '',
      ToMonthYear: '',
      By: this.user.UserId
    }).subscribe({
      next: (response) => {
        this.PerquisiteLoad = response.Table;
        this.Data.empCode = this.row.EmpCode;
        this.Data.empType = this.row.EmpType;
        this.startDate = this.dateFormate.parseMonth(this.row.MonthYear);
        this.Data.monthYear = this.dateFormate.parseMonth(this.row.MonthYear);
        this.Data.perquisite = this.row.ESS_PerquisiteMasterID;
        this.perquisiteName = this.PerquisiteLoad.find((e: any) => e.ESS_PerquisiteMasterID == this.Data.perquisite).Perquisite_Name;
        this.Data.subHeadName = this.row.Sub_PayHead_Name;
        this.Data.grossValue = this.row.Gross_Value;
        this.Data.employeeRecovery = this.row.Employee_Recovery;
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Save(form: any) {
    if (form.valid) {
      this.isDisabled = true;
      const filteredData = [{
        "Action": "Update",
        "ID": this.row.ESS_PerquisiteTransactionDetailsID,
        "EmpCode": this.row.EmpCode,
        "EmpType": this.row.EmpType,
        "MonthYear": this.dateFormate.fullmonth[this.Data.monthYear.month - 1] + ' ' + this.Data.monthYear.year,
        "PerquisiteName": this.perquisiteName,
        "Sub_PayHead_Name": this.Data.subHeadName,
        "Gross_Value": this.Data.grossValue,
        "Employee_Recovery": this.Data.employeeRecovery
      }]
      console.log(filteredData);
      this.comboload.ESS_PerquisiteTransactionDetails_Insert({
        PerquisiteData: filteredData
      }).subscribe({
        next: (response) => {
          if (response.Error_Code == "01") {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              if (result) {
                this.activeModal.close(true);
              }
            });
          } else {
            this.isDisabled = false;
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.ErrorMsg;
            modalRef.result.then((result: any) => {
              this.activeModal.close(true);
            });
          }
          this.isDisabled = false;
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      form.submitted = true;
    }
  }

  close() {
    this.activeModal.close();
  }

  onPerquisiteChange(data: any) {
    this.perquisiteName = this.PerquisiteLoad.find((e: any) => e.ESS_PerquisiteMasterID == data).Perquisite_Name;
  }
}
